export default __webpack_public_path__ + "static/media/refresh-make.80a02998.png";